import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Flame } from "lucide-react";

/**
 * Smart logo/home link.
 * - Not logged in → /
 * - Brand logged in → /painel/marca
 * - Creator logged in → /painel/criador
 * - Admin logged in → /painel/admin
 *
 * Fix P0: usuário logado NÃO deve cair na landing deslogada ao clicar no logo.
 */
export default function HomeLink({ className = "", showText = true, testId = "logo-home-link" }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  const target =
    user && user !== false
      ? user.user_type === "brand"
        ? "/painel/marca"
        : user.user_type === "creator"
        ? "/painel/criador"
        : user.user_type === "admin"
        ? "/painel/admin"
        : "/"
      : "/";

  return (
    <Link
      to={target}
      onClick={(e) => {
        // If already on target, force scroll-to-top for that native "home" feel
        if (window.location.pathname === target) {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }}
      data-testid={testId}
      className={`flex items-center gap-2.5 ${className}`}
    >
      <div className="w-10 h-10 rounded-xl warm-gradient flex items-center justify-center glow-red">
        <Flame className="w-5 h-5 text-white" />
      </div>
      {showText && <div className="font-display font-bold text-xl tracking-tight">Alta Creators</div>}
    </Link>
  );
}
